import dayjs from 'dayjs'

export const MIXIN = {
  data() {
    return {
      tableBG: {
        background: '#f2f2f2',
        color: '#4a4a4a'
      }, //table头部样式
      page_size: 10, // 页面条数
      page_total: 0,
      page_size_opts: [10, 20, 50],
      page_current: 1, //页码
      table_loading: false, //table加载
      // picImg: location.protocol=='http:'?process.env.VUE_APP_BASE_API:process.env.VUE_APP_BASES_API, //'https://www.inspector.ltd', //图片拼接地址
      picImg: 'https://www.inspector.ltd', //图片拼接地址
      subMenuIdx:0,//选项卡下标 
      yuyan:localStorage.getItem('locale')?localStorage.getItem('locale'):'zh',
      admin_ids:localStorage.getItem('admin_ids')
    }
  },
  created() {},
  filters: {
    //取文件后缀名
    getFileType(name){
      var arr = name.split(".");
      return arr[arr.length-1].toLowerCase();
    },
    setData: function (time) {
      return dayjs.unix(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getCharacter: function (row) {
      let str = row;
      if(!str){
        return;
      }
      try{
        let index = str.lastIndexOf("\/");
        str = str.substring(index + 1, str.length);
        // console.log(str)
        return str
      }catch(e){
        console.log(e);
      }
     

    },
    getTwo(num) {
      return Number(num).toFixed(2)
    },
    //  不可操作权限用户邮箱
    setNickName: function (email) {
      let name = '';
      if (typeof email === 'string') {
        name = email.substring(0, 1) + '***'

      }
      return name
    }
  },
  methods: {
    //打开聊天窗口
    openChat(id,val) {
      if(id){
        localStorage.setItem('user_paramas_gid',id)
      }else{
        localStorage.setItem('user_paramas_gid','')
      }
      let userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) :''
      let newObj = {}
      if(userInfo){
        newObj = this.$router.resolve({path:'/groupchat'})
      }else{
        newObj = this.$router.resolve({path:'/visitorchat'})
      }
      window.open(newObj.href,'_blank')
      // let urlObj = this.$router.resolve({path:'/groupchat'})
      // window.open(urlObj.href,'_blank')
      
    },
    //全选checkAll
    checkAll(opt){
      let {  value,list,itemValue } = opt;
      if(!itemValue){
        if(this[value] instanceof Array && this[value].length ===list.length){
           this[value]=[];
        }else{
          this[value] = list.concat(); //传入 纯1维数组
        }
      }else{
       if(this[value] instanceof Array && this[value].length ===list.length){
         this[value]=[];
      }else{
       this[value] = list.map(item=>item[itemValue]);
      }
       
      }
   },
    //取文件后缀名
    getFileType(name){
      var arr = name.split(".");
      return arr[arr.length-1].toLowerCase();
    },
    //input输入框控制数字
    input(value) {
      let result = value.replace(/[^\d]/g, '');
      return result
    },
    overdue: function (time) { //当时间过期后  屏蔽功能
      let timestampNow = new Date(new Date().toLocaleDateString()).getTime(); //获取当前时间

      let d = new Date(time)

      let timestampSet = d.getTime(d)
      let isOverdue = false //未过期
      if (timestampSet < timestampNow) {
        isOverdue = true //已过期
      }
      return isOverdue
    },
    // 文件截取
    getCharacter(row) {
      let str = row;
      if (!str) {
        return '';
      }
      console.log(str);
      try {
        let index = str.lastIndexOf("\/");
        str = str.substring(index + 1, str.length);
        // console.log(str)
        return str
      } catch (e) {
        console.log(e);
      }

    },
    //设置table单元格
    setCellStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      const backgroundColor = rowIndex % 2 == 1 ? '#f2f2f2' : '#ffffff'
      return {
        backgroundColor
      }
    },
    pageChange(page_current) {
      this.page_current = page_current;
      this.getTableData();
    },
    //每页条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getTableData();
    },
    //下载图片
    downloadPic(url) {
      let name = this.getCharacter(url)
      const img = new Image;
      //解决跨域 canvas污染
      img.setAttribute('crossOrigin', 'anonymous');
      //创建canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      img.onload = function () {
        canvas.width = this.width;
        canvas.height = this.height;
        ctx.drawImage(this, 0, 0);
        //这里创建一个a标签
        const elt = document.createElement('a');
        //这里要注意转换成dataURI前必须先确保图片成功加载到，所以.toDataURL()方法应该写img的onload事件中。
        elt.setAttribute('href', canvas.toDataURL('image/jpeg'));
        //a标签添加 download 属性 设置想要的图片名称
        elt.setAttribute('download', name);
        elt.style.display = 'none';
        document.body.appendChild(elt);
        elt.click();
        //最后删除a标签
        document.body.removeChild(elt);
      };
      img.src = url;
    },

    //文件预览
    openFileFind(file) {
      var fileType = file.split(".")[file.split(".").length - 1];
      var officeType = ['doc', 'docx', 'xls', 'xlsx'];
      var picTYpe = ['png', 'gif', 'jpg', 'jpeg','pdf'];
      if (officeType.includes(fileType.toLowerCase())) {
        let url = `https://view.officeapps.live.com/op/view.aspx?src=${this.picImg}${file}`;
        window.open(url);
      } else if (picTYpe.includes(fileType.toLowerCase())) {
        window.open(this.picImg + file);
      }else{
        this.$message.error('暂不支持该文件的预览');
      }
    },

    // 获取文件对应类型图标
    getFileTypeIcon(file) {
      let filetype = this.getFileType(file)
      let path = this.picImg + '/logo/file/';
      return path + filetype + '.png';
    },
  }
};
